module.exports = __webpack_public_path__ + "images/emails/i-help-1b8a4be6.gif";